import Vue from 'vue'
import Vuex from 'vuex'
import EditorWrapper from './src/components/EditorWrapper.vue'

// 确保 Vuex 只被注册一次
if (!Vue._installedPlugins || !Vue._installedPlugins.includes(Vuex)) {
  Vue.use(Vuex)
}

const SsmlEditor = {
  install(Vue) {
    Vue.component('SsmlEditor', EditorWrapper)
  }
}

// 导出插件
export default SsmlEditor